
export default {
  data() {
    return {
      options: [
        {
          name: "icon",
          label: this.$t("label.icon"),
          type: "image",
          size: "16x16",
        },
        {
          name: "description",
          label: this.$t("label.description"),
          type: "tipTap",
        },
      ],

      downloadOptions: [
        {
          name: "image",
          label: this.$t("label.image"),
          type: "image",
          size: "136x40",
        },
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],

      imagesOptions: [
        {
          name: "image",
          label: this.$t("label.image"),
          type: "image",
          size: "80x80",
        },
      ],
    };
  },
};
